import "tldraw/tldraw.css"
import { Container } from "reactstrap"
import { Link } from "react-router-dom"
import React, { useEffect, useState } from "react"
import {
  DefaultToolbar, DefaultToolbarContent, Tldraw, TldrawUiMenuItem, useEditor, createTLStore, loadSnapshot,
  TLStoreWithStatus, defaultShapeUtils, throttle, getSnapshot
} from "tldraw"
import { RulerIcon, RulerShapeUtil, RulerTool } from "../../modules/online-lesson/tldraw/shapes/ruler"
import {
  ProtractorIcon,
  ProtractorShapeUtil,
  ProtractorTool
} from "../../modules/online-lesson/tldraw/shapes/protractor"
import { SetSquareIcon, SetSquareShapeUtil, SetSquareTool } from "../../modules/online-lesson/tldraw/shapes/set-square"
import { SetSquare3060Icon, SetSquare3060ShapeUtil, SetSquare3060Tool } from "../../modules/online-lesson/tldraw/shapes/set-square-30-60"
import './whiteboard.scss'
import { useLocalStore } from "./whiteboard-storage"


function CustomToolbar(props: any) {
  const editor = useEditor()

  return (
    <DefaultToolbar {...props}>
      <DefaultToolbarContent />
      <TldrawUiMenuItem
        id="ruler"
        label="Ruler"
        icon={RulerIcon()}
        onSelect={() => {editor.setCurrentTool('ruler')}}
      />
      <TldrawUiMenuItem
        id="protractor"
        label="Protractor"
        icon={ProtractorIcon()}
        onSelect={() => {editor.setCurrentTool('protractor')}}
      />
      <TldrawUiMenuItem
        id="set-square"
        label="Set Square 45°"
        icon={SetSquareIcon()}
        onSelect={() => {editor.setCurrentTool('set-square')}}
      />
      <TldrawUiMenuItem
        id="set-square-30-60"
        label="Set Square 30/60°"
        icon={SetSquare3060Icon()}
        onSelect={() => {editor.setCurrentTool('set-square-30-60')}}
      />
    </DefaultToolbar>
  )
}


interface WhiteboardPage {}

export const WhiteboardPage = (props: WhiteboardPage)=> {

  const store = useLocalStore();

  return (
    <div id="whiteboard-page" className="page-wrapper list-bg">
      <div className="cs-pg-header bg-dark-blue py-3">
        <Container className="custom-wt">
          <div className="">
            <div className="mt-0">
              <Link className="text-white font-size-14" to={"/"}>
                {" "}
                <span>
                    <i className="fas fa-chevron-left me-1"></i>
                  </span>{" "}
                BACK TO HOME
              </Link>
              <div className="pg-title w-75 m-auto">Whiteboard</div>
            </div>

          </div>
        </Container>
      </div>

      <div id="whiteboard-container" style={{width:'100%', height:'calc(100vh - 120px)'}}>
        <Tldraw
          store={store}
          shapeUtils={[RulerShapeUtil, ProtractorShapeUtil, SetSquareShapeUtil, SetSquare3060ShapeUtil]}
          tools={[RulerTool, ProtractorTool, SetSquareTool, SetSquare3060Tool]}
          components={{
            Toolbar: CustomToolbar,
          }}
        />
      </div>
    </div>

  )
}